import { render, staticRenderFns } from "./DailyBlocks.vue?vue&type=template&id=ad819f8c&scoped=true&"
import script from "./DailyBlocks.vue?vue&type=script&lang=js&"
export * from "./DailyBlocks.vue?vue&type=script&lang=js&"
import style0 from "./DailyBlocks.vue?vue&type=style&index=0&id=ad819f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad819f8c",
  null
  
)

export default component.exports